import * as actionTypes from "actions/actionTypes/offer/financials/offerFinancingStructure";
import * as eventTypes from "actions/eventTypes/offer/financials/offerFinancingStructure";
import initialState from "../../initialState";

export default function financingStructureReducer(state = initialState.currentOffer.financingStructureData, action) {
  switch (action.type) {
    case actionTypes.LOAD_OFFER_FINANCING_STRUCTURE_SUCCEEDED:
      return {
        ...state,
        financingStructure: { ...action.payload },
        financingStructureLoaded: true,
        maxResidualValuePercentLoading: false
      };

    case actionTypes.SAVE_OFFER_FINANCING_STRUCTURE_STARTED:
      return {
        ...state,
        saving: true
      };

    case actionTypes.SAVE_OFFER_FINANCING_STRUCTURE_SUCCEEDED:
      return {
        ...state,
        saving: false,
        financingStructure: action.payload.financingStructure,
        maxResidualValuePercent: null
      };

    case actionTypes.SAVE_OFFER_FINANCING_STRUCTURE_FAILED:
      return {
        ...state,
        financingStructure: {...state.financingStructure},
        saving: false
      };

    case actionTypes.COMPUTE_OFFER_FINANCING_STRUCTURE_MAX_RESIDUAL_VALUE_STARTED:
      return {
        ...state,
        maxResidualValuePercentLoading: true
      };

    case actionTypes.COMPUTE_OFFER_FINANCING_STRUCTURE_MAX_RESIDUAL_VALUE_SUCCEEDED:
      return {
        ...state,
        maxResidualValuePercent: action.payload.maxResidualValuePercent,
        maxResidualValuePercentLoading: false
      };

    case actionTypes.COMPUTE_OFFER_FINANCING_STRUCTURE_MAX_RESIDUAL_VALUE_FAILED:
      return {
        ...state,
        maxResidualValuePercentLoading: false
      };

    case actionTypes.CANCEL_OFFER_FINANCING_STRUCTURE_CHANGES:
      return {
        ...state,
        maxResidualValuePercent: null
      };

    case eventTypes.OFFER_FINANCING_STRUCTURE_INVALIDATED:
    case eventTypes.OFFER_FINANCING_PAYMENT_PLAN_INVALIDATED: ////??????????????????????????????????????
      return initialState.currentOffer.financingStructureData;

    default:
      return state;
  }
}
